import type * as hast from 'hast';

import { BLOCK_QUOTE } from '@gitbook/doc-core';
import { Block } from '@gitbook/slate';

import type { HastToGastTransformMap } from './types';

export const transformBlockQuotes: HastToGastTransformMap = {
    blockquote: async (node: hast.Element, eat, context) => {
        return [
            Block.create({
                type: BLOCK_QUOTE,
                nodes: await eat('blocks', node.children, context),
            }),
        ];
    },
};
